import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { CenteredPage } from '../components/Shell';
import { useT } from '../hooks';
import { useServices } from '../services';

/** OIDC redirect target: exchanges the code (PKCE) and returns to the original page. */
export function CallbackPage() {
  const t = useT();
  const navigate = useNavigate();
  const { session } = useServices();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    session
      .completeSignin()
      .then((returnTo) => {
        if (active) void navigate(returnTo, { replace: true });
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [session, navigate]);

  return (
    <CenteredPage>
      {failed ? (
        <>
          <p role="alert">{t('operator.login.callbackFailed')}</p>
          <button type="button" className="button button--primary button--block" onClick={() => void navigate('/login', { replace: true })}>
            {t('operator.login.signIn')}
          </button>
        </>
      ) : (
        <p role="status" aria-busy="true">
          {t('operator.login.completing')}
        </p>
      )}
    </CenteredPage>
  );
}
